export default __webpack_public_path__ + "static/media/img-0712-belgium-premium-face.ba4f60e5.png";